import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AnimateHeight from 'react-animate-height';
import _get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { CSSTransition } from 'react-transition-group';
import { connect } from 'react-redux';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import WarningNew from 'yoda-core-components/lib/assets/svg/WarningNew.svg';
import Alert from 'yoda-core-components/lib/assets/svg/Alert.svg';
import SuccessCheck from 'yoda-core-components/lib/assets/svg/SuccessCheck.svg';
import * as styles from './CouponCard.css';
import Config from './CouponConfig';
import CouponUtilsHelper from '../CouponList/CouponUtilsHelper';
import { selectApplyingToEmptyCart } from '../../selectors/ContextSelector';

const cx = classNames.bind(styles);

const renderOfferDetails = (data, displayCouponType) => {
    const couponInfoHtml = [];
    const couponOffers = (data.content && data.content.offers) || [];
    couponOffers.forEach((offerItem, index) => {
        const { bodyCopy, headLine } = offerItem;
        const conjunction = index ? (
            <span className={cx('couponConjunction')}> {offerItem.conjunction || 'OR'}</span>
        ) : (
            ''
        );
        couponInfoHtml.push(
            <div data-automation-id={`at-coupon-count-${index}`}>
                {displayCouponType && conjunction}
                <h4 data-automation-id="at-coupon-name" className={cx('couponCode')}>
                    {index && !displayCouponType
                        ? `${offerItem.conjunction || 'OR'} ${headLine}`
                        : headLine}
                </h4>
                <p data-automation-id="at-coupon-description" className={cx('couponCodeDetails')}>
                    {bodyCopy}
                </p>
            </div>
        );
    });

    return couponInfoHtml;
};

const CSS_TRANSITION_MOVE_DOWN = 'movedown';
const CSS_TRANSITION_MOVE_UP = 'moveup';
const CSS_TRANSITION_TIMER = 400;

/* istanbul ignore next */
const currencyDisp = (savings) => <>${savings.toFixed(2)}</>;

export class CouponInfo extends Component {
    static propTypes = {
        couponData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        displayCouponType: PropTypes.bool,
        couponApplicationState: PropTypes.object,
        appliedAdjustments: PropTypes.array,
        applyingToEmptyCart: PropTypes.bool,
        couponPopupMessages: PropTypes.array,
        setAnimation: PropTypes.func,
        setApplyCouponRequest: PropTypes.func,
        inlineMessaging: PropTypes.bool,
    };

    static defaultProps = {
        couponData: [],
        couponVariant: 'Default',
        openLinkInNewTab: false,
        redeemingChannel: 'TOF',
        printConfig: true,
        displayCouponType: false,
        couponApplicationState: {},
        appliedAdjustments: [],
        applyingToEmptyCart: false,
        couponPopupMessages: [],
        inlineMessaging: false,
        setApplyCouponRequest: () => {},
        setAnimation: () => {},
    };

    static getDerivedStateFromProps(props, state) {
        if (!props.inlineMessaging) {
            return null;
        }
        const selectedCoupon = _get(props, 'couponApplicationState.selectedCouponCode');
        const appliedPromo = _get(props, 'couponApplicationState.response.data.value', false);
        const couponPromo = _get(props, 'couponData.content.promoCode', false);
        const openDrawerCall = _get(props, 'couponApplicationState.openDrawerCall', false);
        const couponListId = _get(props, 'couponData.id', false);
        const isMyCoupon = couponListId === props.applyCouponRequest;
        const { isApplySuccess, isRemoveSuccess } = _get(props, 'couponApplicationState', false);
        const newState = {};
        if (openDrawerCall) {
            const response = _get(props, 'couponApplicationState.selectedCoupon.response', {});
            const { couponData } = props;
            const { appliedAdjustments } = props;
            newState.appliedCouponInfo = CouponUtilsHelper.getAppliedCouponInfo(
                response,
                [couponData],
                appliedAdjustments,
                props.applyingToEmptyCart
            );
        }
        const { UI_STATE } = state;
        if (
            appliedPromo &&
            appliedPromo === couponPromo &&
            !(UI_STATE === 'SUCCESS' || UI_STATE === 'TO_SUCCESS') &&
            props.appliedAdjustments.length > 0 &&
            isApplySuccess
        ) {
            if (isMyCoupon) {
                newState.UI_STATE = 'TO_SUCCESS';
                newState.doAnimation = false;
            } else {
                newState.UI_STATE = 'SUCCESS';
            }
        } else if (UI_STATE === 'SUCCESS' && isApplySuccess && appliedPromo !== couponPromo) {
            newState.UI_STATE = 'REMOVE';
        }

        if (!(UI_STATE === 'REMOVE' || UI_STATE === 'TO_REMOVE') && isRemoveSuccess) {
            if (
                isMyCoupon &&
                selectedCoupon &&
                state.appliedCouponInfo &&
                selectedCoupon === couponPromo
            ) {
                newState.UI_STATE = 'TO_REMOVE';
                newState.doAnimation = false;
            } else if (UI_STATE === 'SUCCESS') {
                newState.UI_STATE = 'REMOVE';
            }
        }

        if (
            isMyCoupon &&
            props.couponPopupMessages.length > 0 &&
            (UI_STATE === 'INFO' || UI_STATE === 'REMOVE')
        ) {
            newState.UI_STATE = 'INFO_TO_ERROR';
            newState.prevCouponPopupMessages = props.prevCouponPopupMessages;
        }
        if (
            state.UI_STATE === 'ERROR' &&
            _get(state, 'prevCouponPopupMessages', []).length > 0 &&
            props.couponPopupMessages.length === 0
        ) {
            if (isMyCoupon) {
                newState.UI_STATE = 'ERROR_TO_INFO';
            } else {
                newState.UI_STATE = 'INFO';
                newState.prevCouponPopupMessages = [];
            }
        }
        if (UI_STATE === 'INFO') {
            newState.doAnimation = false;
        }
        return isEmpty(newState) ? null : newState;
    }

    constructor() {
        super();
        this.state = {
            doAnimation: false,
            running: false,
            UI_STATE: 'INFO',
        };
    }

    shouldComponentUpdate(nextprops, nextstate) {
        return !(this.state.doAnimation === true && nextstate.doAnimation === true);
    }

    componentDidUpdate() {
        if (!this.state.doAnimation) {
            switch (this.state.UI_STATE) {
                case 'TO_SUCCESS':
                case 'TO_REMOVE':
                case 'INFO_TO_ERROR':
                case 'ERROR_TO_INFO':
                    this.startAnimation();
                    break;
                default:
            }
        }
    }

    setAnimationStart() {
        this.props.setAnimation(true);
        this.setState({ running: true });
    }

    setAnimationEnd(UI_STATE) {
        const newState = { doAnimation: false, running: false };
        newState.UI_STATE = UI_STATE;
        newState.appliedCouponInfo = undefined;
        this.props.setAnimation(false);
        if (UI_STATE === 'INFO') {
            newState.prevCouponPopupMessages = [];
        } else {
            newState.prevCouponPopupMessages = this.props.couponPopupMessages;
            this.props.setApplyCouponRequest('');
        }
        this.setState(newState);
    }

    setSuccessAnimationEnd(appliedCouponInfo) {
        const newState = { doAnimation: false, running: false };
        this.props.setAnimation(false);
        newState.prevCouponPopupMessages = [];
        if (appliedCouponInfo) {
            newState.appliedCouponInfo = appliedCouponInfo;
            newState.UI_STATE = 'SUCCESS';
        } else {
            newState.appliedCouponInfo = undefined;
            newState.UI_STATE = 'REMOVE';
            this.props.setApplyCouponRequest('');
        }
        this.setState(newState);
    }

    getCSSTransition(config) {
        const cssTransition = [
            <CSSTransition
                in={!config.doAnimation}
                timeout={CSS_TRANSITION_TIMER}
                classNames={CSS_TRANSITION_MOVE_DOWN}
                unmountOnExit
                onExited={config.onExited}
            >
                <div className={config.moveDownCss}> {config.moveDown} </div>
            </CSSTransition>,
            <CSSTransition
                in={config.doAnimation}
                timeout={CSS_TRANSITION_TIMER}
                classNames={CSS_TRANSITION_MOVE_UP}
                onEnter={config.onEnter}
                unmountOnExit
            >
                <div className={config.moveUpCss}> {config.moveUp} </div>
            </CSSTransition>,
        ];
        return cssTransition;
    }

    getAnimationContainer(elements) {
        const isMobile = _get(this.props, 'deviceType.isMobile', false);
        return isMobile ? (
            <AnimateHeight
                className={cx('animationContainer')}
                duration={100}
                delay={20}
                height="100%"
            >
                {elements}
            </AnimateHeight>
        ) : (
            <div className={cx('animationContainer')}>{elements}</div>
        );
    }

    startAnimation = () => this.setState({ doAnimation: true });

    prepareCouponInfoFailureUI({ title, selectedCoupon }) {
        const errorMessages = [];
        if (Array.isArray(title)) {
            const ftitle = _get(title, '[0]', '').replace(/{[^{}]+}/g, selectedCoupon);
            errorMessages.push(<span className={cx('errorHighlight')}>{ftitle}</span>);
            errorMessages.push(<br />);
            errorMessages.push(<span className={cx('errorNormal')}>{_get(title, '[1]', '')}</span>);
        } else {
            errorMessages.push(<span className={cx('errorNormal')}>{title}</span>);
        }
        const couponInfoFailureUI = (
            <div
                className={cx('couponInfoBlock', 'couponInfoError')}
                data-automation-id="at-coupon-info-block"
            >
                <div className={cx('couponStatusIcon')}>
                    <Icon
                        iconType="svg"
                        automationId="coupon-applied"
                        width="96px"
                        height="96px"
                        viewBox="0 0 96 96"
                        className={cx('icon')}
                    >
                        <Alert />
                    </Icon>
                </div>
                {errorMessages}
            </div>
        );
        return couponInfoFailureUI;
    }

    prepareCouponInfoSuccessUI(appliedCouponInfo) {
        /* istanbul ignore next */
        const showMsg =
            appliedCouponInfo.message &&
            (appliedCouponInfo.message.includes(Config.COUPON_QUAL_ORIG_MSG)
                ? Config.COUPON_QUAL_TRANS_MSG
                : appliedCouponInfo.message);

        const svgComponent = (
            <Icon
                iconType="svg"
                automationId="coupon-applied"
                width="96px"
                height="96px"
                viewBox="0 0 96 96"
                className={cx('icon')}
            >
                {appliedCouponInfo.level === 1 ? <WarningNew /> : <SuccessCheck />}
            </Icon>
        );
        return (
            <div
                className={cx('couponInfoBlock', 'couponInfoSuccess')}
                data-automation-id="at-coupon-info-block"
            >
                <div className={cx('couponStatusIcon')}>{svgComponent}</div>
                <div className={cx('couponStatus')}>{appliedCouponInfo.title}</div>
                {appliedCouponInfo.savings ? (
                    <div data-automation-id="at-saved-amt-msg" className={cx('savedPriceInfo')}>
                        You are saving {currencyDisp(appliedCouponInfo.savings)}
                    </div>
                ) : (
                    ''
                )}
                <div
                    data-automation-id="at-coupon-msg"
                    className={cx('couponMessage')}
                    dangerouslySetInnerHTML={{ __html: showMsg }} // eslint-disable-line react/no-danger
                />
            </div>
        );
    }

    renderInfo() {
        const {
            couponData,
            displayCouponType,
            couponApplicationState,
            appliedAdjustments,
            applyingToEmptyCart,
            inlineMessaging,
        } = this.props;
        let couponInfoSuccessHtml = (
            <div className={cx('couponInfoBlock')} data-automation-id="at-coupon-info-block">
                {renderOfferDetails(couponData, displayCouponType)}
            </div>
        );
        const { UI_STATE } = this.state;
        const appliedPromo = _get(couponApplicationState, 'response.data.value', false);
        const couponPromo = _get(couponData, 'content.promoCode', false);
        const selectedCoupon = _get(couponApplicationState, 'selectedCouponCode');
        const prevCouponPopupMessages = _get(this, 'state.prevCouponPopupMessages', []);
        const selectedCouponPromo = _get(
            couponApplicationState,
            'selectedCoupon.response.data.value',
            false
        );
        if (
            inlineMessaging &&
            selectedCouponPromo &&
            selectedCouponPromo === couponPromo &&
            appliedPromo !== couponPromo
        ) {
            const { response } = couponApplicationState.selectedCoupon;
            const appliedCouponInfo = CouponUtilsHelper.getAppliedCouponInfo(
                response,
                [couponData],
                appliedAdjustments,
                applyingToEmptyCart
            );
            couponInfoSuccessHtml = this.prepareCouponInfoSuccessUI(appliedCouponInfo);
            return couponInfoSuccessHtml;
        }

        // Success Scenario
        if (UI_STATE === 'TO_SUCCESS' && appliedPromo === couponPromo) {
            const { response } = couponApplicationState;
            const appliedCouponInfo = CouponUtilsHelper.getAppliedCouponInfo(
                response,
                [couponData],
                appliedAdjustments,
                applyingToEmptyCart,
                appliedPromo
            );

            const couponInfoUI = couponInfoSuccessHtml;
            const couponInfoSuccessUI = this.prepareCouponInfoSuccessUI(appliedCouponInfo);
            const cssTransition = this.getCSSTransition({
                doAnimation: this.state.doAnimation,
                onExited: () => this.setSuccessAnimationEnd(appliedCouponInfo),
                moveDownCss: cx('animationInfo'),
                moveDown: couponInfoUI,
                onEnter: () => this.setAnimationStart(),
                moveUpCss: cx('animationSuccess'),
                moveUp: couponInfoSuccessUI,
            });
            couponInfoSuccessHtml = this.getAnimationContainer(cssTransition);
        } else if (UI_STATE === 'SUCCESS' && appliedPromo === couponPromo) {
            const { response } = couponApplicationState;
            const appliedCouponInfo = CouponUtilsHelper.getAppliedCouponInfo(
                response,
                [couponData],
                appliedAdjustments,
                applyingToEmptyCart,
                appliedPromo
            );
            const couponInfoSuccessUI = this.prepareCouponInfoSuccessUI(appliedCouponInfo);
            couponInfoSuccessHtml = this.getAnimationContainer(couponInfoSuccessUI);
        } else if (UI_STATE === 'TO_REMOVE' && selectedCoupon === couponPromo) {
            const couponInfoUI = couponInfoSuccessHtml;
            const couponInfoSuccessUI = this.prepareCouponInfoSuccessUI(
                this.state.appliedCouponInfo
            );
            const cssTransition = this.getCSSTransition({
                doAnimation: this.state.doAnimation,
                onExited: () => this.setSuccessAnimationEnd(),
                moveDownCss: cx('animationSuccess'),
                moveDown: couponInfoSuccessUI,
                onEnter: () => this.setAnimationStart(),
                moveUpCss: cx('animationInfo'),
                moveUp: couponInfoUI,
            });
            couponInfoSuccessHtml = this.getAnimationContainer(cssTransition);
        } else if (UI_STATE === 'REMOVE' && selectedCoupon === couponPromo) {
            couponInfoSuccessHtml = this.getAnimationContainer(couponInfoSuccessHtml);
        } else if (UI_STATE === 'INFO_TO_ERROR' && selectedCoupon === couponPromo) {
            const { title } = _get(this.props, 'couponPopupMessages[0]', {});
            const couponInfoFailureUI = this.prepareCouponInfoFailureUI({ title, selectedCoupon });
            const couponInfoUI = couponInfoSuccessHtml;
            const cssTransition = this.getCSSTransition({
                doAnimation: this.state.doAnimation,
                onExited: () => this.setAnimationEnd('ERROR'),
                moveDownCss: cx('animationInfo'),
                moveDown: couponInfoUI,
                onEnter: () => this.setAnimationStart(),
                moveUpCss: cx('animationFailure'),
                moveUp: couponInfoFailureUI,
            });
            couponInfoSuccessHtml = this.getAnimationContainer(cssTransition);
        } else if (UI_STATE === 'ERROR' && selectedCoupon === couponPromo) {
            const { title } = _get(this.props, 'couponPopupMessages[0]', {});
            const couponInfoFailureUI = this.prepareCouponInfoFailureUI({ title, selectedCoupon });
            couponInfoSuccessHtml = this.getAnimationContainer(couponInfoFailureUI);
        } else if (UI_STATE === 'ERROR_TO_INFO' && selectedCoupon === couponPromo) {
            const title = _get(prevCouponPopupMessages, '[0].title', {});
            const couponInfoFailureUI = this.prepareCouponInfoFailureUI({ title, selectedCoupon });
            const couponInfoUI = couponInfoSuccessHtml;
            const cssTransition = this.getCSSTransition({
                doAnimation: this.state.doAnimation,
                onExited: () => this.setAnimationEnd('INFO'),
                moveDownCss: cx('animationFailure'),
                moveDown: couponInfoFailureUI,
                onEnter: () => this.setAnimationStart(),
                moveUpCss: cx('animationInfo'),
                moveUp: couponInfoUI,
            });
            couponInfoSuccessHtml = this.getAnimationContainer(cssTransition);
        } else if (selectedCoupon !== couponPromo) {
            this.props.setApplyCouponRequest('');
        }

        return couponInfoSuccessHtml;
    }

    render() {
        const couponsInfoHtml = this.renderInfo();

        return <div>{couponsInfoHtml}</div>;
    }
}

const mapStateToProps = (state) => ({
    appliedAdjustments: state.appliedAdjustments,
    applyingToEmptyCart: selectApplyingToEmptyCart(state),
    couponApplicationState: state.couponApplicationState,
    couponPopupMessages: state.messages && state.messages[Config.COUPON_POPUP_MESSAGES_ID],
});

export default connect(mapStateToProps)(CouponInfo);
